import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstPr2: [],
		pr2: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getPr2: state => state.pr2,
		getUpdate: state => state.update,
		getPr2produto: state => state.pr2.pr2produto,
		getPr2opcao: state => state.pr2.pr2opcao,
		getItensPerPage: state => state.itemsPerPage,
		getSearch: state => state.search,
	},
	mutations: {
		setPr2(state, pr2) {
			state.pr2 = pr2
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.pr2 = null
		},
		setLstPr2(state, payload) {
			state.lstPr2 = payload.items
		},
		setLoading(state, payload) {
			state.loading = payload
		},
		setItemsPerPage(state, payload) {
			state.itemsPerPage = payload
		},
		setSearch(state, payload) {
			state.search = payload
		},
		setHasNext(state, payload) {
			state.hasNext = payload
		},
	},
	actions: {
		async find({ commit, dispatch }, { pr2produto, pr2opcao }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Pesquisando", indeterminate: true },
				{ root: true },
			)
			commit("initForm")
			await this._vm.$axios
				.get(`/Products/ColorOptions/Find/${pr2produto}/${pr2opcao}`)
				.then(response => {
					let pr2 = Utils.ValidateAxiosResponse(response.data)
					commit("set", pr2)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		save({ getters, dispatch }) {
			if (getters.getUpdate) 
                return dispatch("update")
			return dispatch("insert")
		},
		async insert({ getters, dispatch, commit }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.post("/Products/ColorOptions/Insert", getters.getPr2)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("setPr2", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Atualizando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.put("/Products/ColorOptions/Update", getters.getPr2)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("setPr2", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async verifyChildrenAndDeletePermission({ dispatch }, { pr2produto, pr2opcao } ){
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            var payload = await this._vm.$axios.get(`/Products/ColorOptions/VerifyChildrenAndDeletePermission/`, { params: { pr2produto, pr2opcao } })
                .then(response => {
					Utils.ValidateAxiosResponse(response.data)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return true
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Products/ColorOptions/Delete/${getters.getPr2produto}/${getters.getPr2opcao}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async saveAll({ dispatch }, { pr2produto, lstPr2 }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando lista de cores", indeterminate: true },
				{ root: true },
			)
			lstPr2 = lstPr2.map(pr2 => {
				pr2.pr2produto = pr2produto
				pr2.pr2foracat = pr2.pr2foracat == 1
				return pr2
			})
			let payload = await this._vm.$axios
				.post("/Products/ColorOptions/SaveAll/", lstPr2, { params: { pr2produto: pr2produto } })
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{ titleText: "Erro", titleColor: "red", text: error.message },
						{ root: true },
					)
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async saveImage({ dispatch }, { pr2produto, pr2opcao, pr2image }) {
			const formData = new FormData()
			formData.append("image", pr2image)

			let payload = await this._vm.$axios
				.post("/Products/Image/Save/PR2/" + pr2produto + "/" + pr2opcao, formData)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{ titleText: "Erro", titleColor: "red", text: error.message },
						{ root: true },
					)
					return null
				})
			return payload
		},
		async deleteImage({ dispatch }, { pr2produto, pr2opcao }) {
			let payload = await this._vm.$axios
				.delete("/Products/Image/Delete/PR2/" + pr2produto + "/" + pr2opcao)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{ titleText: "Erro", titleColor: "red", text: error.message },
						{ root: true },
					)
					return null
				})
			return payload
		},
		async findList({ commit, dispatch }, pr2produto) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Pesquisando", indeterminate: true },
				{ root: true },
			)
			commit("initForm")
			let payload = await this._vm.$axios
				.get("/Products/ProductSize/FindList/" + pr2produto)
				.then(response => {
					let lstPr2 = Utils.ValidateAxiosResponse(response.data)
					commit("setLstPr2", lstPr2)
					return true
				})
				.catch(error => {
					commit("setLstPr2", [])
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async search({ commit, getters, dispatch }, page = 1) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Pesquisando", indeterminate: true },
				{ root: true },
			)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Products/ProductSize/Search?search=${getters.getSearch}&limit=${getters.getItensPerPage}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setLstPr2", payload.items)
					commit("setItemsPerPage", payload.limit)
					commit("setHasNext", payload.hasNext)
					return true
				})
				.catch(error => {
					commit("setLstPr2", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async saveAllImages({ dispatch }, { pr2produto, lstPr2, isFromPr0Screen = false }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando imagens das cores", indeterminate: true },
				{ root: true },
			)
			let payload = true
			for (const pr2 of lstPr2) {
				const formData = new FormData()
				const image = isFromPr0Screen ? pr2.pr2imgdata : pr2.pr2image
				if(image != null && image != ""){
					formData.append("image", image)
					payload = await this._vm.$axios
						.post("/Products/Image/Save/PR2/" + pr2produto + "/" + pr2.pr2opcao, formData, 
						)
						.then(response => {
							return Utils.ValidateAxiosResponse(response.data)
						})
						.catch(error => {
							dispatch(
								"parameters/openDialog",
								{ titleText: "Erro", titleColor: "red", text: error.message },
								{ root: true },
							)
							return null
						})
				}
			}
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	},
}
